import { LoadingSpinner } from '../../../../../components/LoadingSpinner/LoadingSpinner';

/**
 * MapLoadingOverlay component renders a loading spinner overlay.
 *
 * This component displays a full-screen loading spinner with a semi-transparent white background.
 * It is positioned absolutely to cover the entire parent container and centers the spinner both
 * vertically and horizontally.
 *
 * @component
 * @example
 * return (
 *   <MapLoadingOverlay />
 * )
 */
export const MapLoadingOverlay = () => (
  <LoadingSpinner className="z-high absolute inset-0 m-0 flex size-full items-center justify-center! bg-white/25 p-0" />
);
